const {Component} = require("react");
const cartStore = require("stores/CartStore");
const slotStore = require("stores/HourSlotsStore");
const Form = require("components/forms/Form");
const Textarea = require("components/forms/Textarea");
const Load = require("components/mixins/Load");
const Modal = require("components/modals/Modal");
const Date = require("components/forms/Date");
const Select = require("components/forms/Select");
const router = require("services/router");
const moment = require("moment");
const assign = require("object-assign");

class RequestForm extends Form {
	constructor(props) {
		super(props);

		assign(this.state, {
			from: this.dateTime.clone().format("HH:mm"),
			to: this.dateTime.clone().add(1, 'h').format("HH:mm")
		});
	}

	/*
	 * Getters
	 */
	get actionLabel() {
		return "Godkend valg";
	}

	get dateTime() {
		return slotStore.constraints.after ? moment(slotStore.constraints.after) : moment();
	}

	get bookable() {
		return cartStore.attributes.bookable;
	}

	get hourOptions() {
		const options = [];
		const start = moment().startOf('day');

		for (let i=7; i<24; i++) {
			let from = start.clone().add(i, 'h');

			options.push({
				raw:	from,
				value:	from.format("HH:mm"),
				label:	from.format("HH:mm"),
			});
		}

		return options;
	}

	get endHourOptions() {
		return this.hourOptions .map(hour => {
			let to = hour.raw.clone().add(1, 'h');

			return {
				value:	to.format("HH:mm"),
				label:	to.format("HH:mm"),
			};
		});
	}

	/*
	 * Actions
	 */
	send(form) {
		const data	= new FormData(form);
		const msg	= data.get('msg');
		const from	= `${data.get('date')} ${data.get('from')}`;

		const end	= data.get('to');
		const to	= end === '00:00' ?
			`${moment(data.get('date')).add(1, 'd').format('YYYY-MM-DD')} ${end}` :
			`${data.get('date')} ${end}`;

		return cartStore.addMany(from, to, msg);
	}

	handleSuccess(message) {
		this.setState({
			loading: false,
			message: message,
			errors: {}
		}, () => {
			if (typeof this.props.onSuccess === "function") {
				this.props.onSuccess();
			}
		});
	}

	handleFromChange = (e) => {
		this.setState({from: e.target.value});
	}

	handleToChange = (e) => {
		this.setState({to: e.target.value});
	}

	renderDateTimeError() {
		const errors = this.state.errors;
		const errorsMarkup = Object.keys(errors).map(key => {
			const message = errors[key][0];

			return (
				<p className="error" key={key}>{message}</p>
			);
		});

		return (
			<div className="errors">
				{errorsMarkup}
			</div>
		);
	}

	renderHeader() {
		return (
			<div className="form-header top-bar"> 
				<p className="title">Forespørg {this.bookable.nickname} om et tidspunkt som <span>ikke</span> er registreret i vores system</p> 
				{this.renderDateTimeError()}
			</div> 
		);
	}

	renderBody() {
		return (
			<div className="form-body">
				<Date className="full-width" label="Vælg dato" name="date"
						min={this.dateTime.toISOString()} defaultValue={this.dateTime.format("YYYY-MM-DD")} >
					<img src={router.url("img/icons/choose-date.svg")} alt="Choose date"/>
				</Date>

				<Select label="Vælg starttidspunkt" name="from"
						options={this.hourOptions} value={this.state.from} onChange={this.handleFromChange} >
					<img src={router.url("img/icons/clock.svg")} alt="Choose time"/>
				</Select>

				<Select label="Vælg sluttidspunkt" name="to"
						options={this.endHourOptions} value={this.state.to} onChange={this.handleToChange} >
					<img src={router.url("img/icons/clock.svg")} alt="Choose time"/>
				</Select>

				<Textarea label="Din besked" className="full-width" name="msg" required={true} placeholder="Din besked..."/>
			</div>
		);
	}

	renderFooter() {
		return (
			<div className="form-footer">
				<div className="actions">
					{this.renderActions()}
					<button type="submit" className="btn" disabled={this.loading}>{this.actionLabel}
						<Load></Load>
					</button>
				</div>
			</div>
		);
	 }
}

class BookingRequest extends Component {

	close = () => {
		this.modal.close();
	}

	render() {
		return (
			<div className="cta">
				<button className="btn" onClick={() => this.modal.open()} >
					Forespørg om anden tid
				</button>

				<Modal ref={el => this.modal = el}>
					<section className="request-booking">
						<RequestForm onSuccess={this.close} />
					</section>
				</Modal>
			</div>
		);
	}
}

module.exports = BookingRequest;



// WEBPACK FOOTER //
// ./resources/js/components/checkout/BookingRequest.js